import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Agenda from '../views/Agenda.vue'
import Hongkong from '../views/onepager/hongkong.vue'
import Paris from '../views/onepager/paris.vue'
import Denver from '../views/onepager/denver.vue'
import Dubai from '../views/onepager/dubai.vue'
import Toronto from '../views/onepager/toronto.vue'
import Vegas from '../views/onepager/vegas.vue'
import Tokyo from '../views/onepager/tokyo.vue'
import Korea from '../views/onepager/korea.vue'
import Singapore from '../views/onepager/singapore.vue'
import Argentina from '../views/onepager/argentina.vue'
import SingaporeHome from '../views/singapore/Home.vue'
import SingaporeSponsor from '../views/singapore/Sponsor.vue'
import SingaporeEntertainment from '../views/singapore/Entertainment.vue'
import SingaporeSchedule from '../views/singapore/Schedule.vue'
import KoreaHome from '../views/korea/Home.vue'
import KoreaSponsor from '../views/korea/Sponsor.vue'
import KoreaEntertainment from '../views/korea/Entertainment.vue'
import KoreaSchedule from '../views/korea/Schedule.vue'
import NashvilleHome from '../views/nashville/Home.vue'
import NashvilleSponsor from '../views/nashville/Sponsor.vue'
import NashvilleEntertainment from '../views/nashville/Entertainment.vue'
import NashvilleSchedule from '../views/nashville/Schedule.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/denver',
    name: 'Denver',
    component: Denver
  },
  {
    path: '/hongkong',
    name: 'Hongkong',
    component: Hongkong
  },
  {
    path: '/paris',
    name: 'Paris',
    component: Paris
  },
  {
    path: '/dubai',
    name: 'Dubai',
    component: Dubai
  },
  {
    path: '/toronto',
    name: 'Toronto',
    component: Toronto
  },
  {
    path: '/vegas',
    name: 'Vegas',
    component: Vegas
  },
  {
    path: '/tokyo',
    name: 'Tokyo',
    component: Tokyo
  },
  {
    path: '/korea',
    name: 'Korea',
    component: Korea
  },
  {
    path: '/singapore',
    name: 'Singapore',
    component: Singapore
  },
  {
    path: '/argentina',
    name: 'Argentina',
    component: Argentina
  },
  {
    path: '/luma',
    name: 'Agenda',
    component: Agenda
  },
  {
    path: '/singapore-24',
    name: 'Singapore Home',
    component: SingaporeHome
  },
  {
    path: '/singapore-24/sponsorships',
    name: 'Singapore Sponsorships',
    component: SingaporeSponsor
  },
  {
    path: '/singapore-24/entertainment',
    name: 'Singapore Entertainment',
    component: SingaporeEntertainment
  },
  {
    path: '/singapore-24/schedule',
    name: 'singapore Schedule',
    component: SingaporeSchedule
  },
  {
    path: '/korea-24',
    name: 'korea Home',
    component: KoreaHome
  },
  {
    path: '/korea-24/sponsorships',
    name: 'korea Sponsorships',
    component: KoreaSponsor
  },
  {
    path: '/korea-24/entertainment',
    name: 'korea Entertainment',
    component: KoreaEntertainment
  },
  {
    path: '/korea-24/schedule',
    name: 'korea Schedule',
    component: KoreaSchedule
  },
  {
    path: '/nashville',
    name: 'Nashville Home',
    component: NashvilleHome
  },
  {
    path: '/nashville/sponsorships',
    name: 'Nashville Sponsorships',
    component: NashvilleSponsor
  },
  {
    path: '/nashville/entertainment',
    name: 'Nashville Entertainment',
    component: NashvilleEntertainment
  },
  {
    path: '/nashville/schedule',
    name: 'Nashville Schedule',
    component: NashvilleSchedule
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/luma'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
